var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      staticClass: "modalNotificar",
      attrs: { titulo: _vm.titulo(), width: _vm.width },
      on: {
        closeModal: function($event) {
          return _vm.$emit("closeModal")
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _vm.showModalNotificacao
            ? _c("app-modal-selecionar-modelo-notificacao", {
                attrs: {
                  tiposModelo: _vm.tiposModelo,
                  titulo: "Modelos de Notificação",
                  idProcesso: this.idProcesso,
                  showModal: _vm.showModalNotificacao
                },
                on: {
                  closeModal: _vm.fecharModalNotificacao,
                  setTextoNotificacao: _vm.setTextoNotificacao
                }
              })
            : _vm._e(),
          _vm.showModalVisualizaPdf
            ? _c("app-modal-visualiza-pdf", {
                attrs: {
                  titulo: _vm.tituloModal,
                  tipo: _vm.tipoModal,
                  conteudo: _vm.conteudoModal,
                  isVTN: false,
                  isImagem: _vm.isImagem,
                  tituloDocumento: _vm.tituloDocumento
                },
                on: { closeModal: _vm.closeModalVisualizaPdf }
              })
            : _vm._e(),
          _vm._l(_vm.conversas, function(item) {
            return (_vm.conversas.length > 0 &&
              item.tipo === "NOTIFICACAO_INTERESSADO") ||
              item.assunto === "Solicitação de cópia do processo"
              ? _c(
                  "div",
                  { key: item.id, staticClass: "mb" },
                  [
                    _c("p", [
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            item.tipo === "NOTIFICACAO_INTERESSADO"
                              ? "Notificação"
                              : "Mensagem"
                          ) +
                            ":  " +
                            _vm._s(item.assunto)
                        )
                      ])
                    ]),
                    _c(
                      "el-collapse",
                      _vm._l(item.mensagemList, function(msg) {
                        return _c(
                          "el-collapse-item",
                          { key: msg.id, attrs: { name: msg.id } },
                          [
                            _c("template", { slot: "title" }, [
                              _c(
                                "div",
                                { staticClass: "flex title full-width" },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(msg.nomeRemetente))
                                  ]),
                                  _c("span", [
                                    _vm._v(_vm._s(msg.dataEnviada) + "  ")
                                  ])
                                ]
                              )
                            ]),
                            msg.dataLimiteResposta
                              ? _c("el-row", { staticClass: "margin-top" }, [
                                  _c("p", [
                                    _c("b", [_vm._v("Data de vencimento:")]),
                                    _c("span", [
                                      _vm._v(
                                        "  " + _vm._s(msg.dataLimiteResposta)
                                      )
                                    ])
                                  ])
                                ])
                              : _vm._e(),
                            _c("el-row", { staticClass: "margin-top" }, [
                              _c("p", {
                                domProps: { innerHTML: _vm._s(msg.conteudo) }
                              })
                            ]),
                            _c(
                              "el-row",
                              [
                                _c(
                                  "el-table",
                                  {
                                    attrs: {
                                      data: msg.anexoList,
                                      stripe: "stripe"
                                    }
                                  },
                                  [
                                    _c("el-table-column", {
                                      staticClass: "td-column-anexo",
                                      attrs: { prop: "nome" }
                                    }),
                                    _c("el-table-column", {
                                      staticClass: "td-column-anexo",
                                      attrs: { align: "center", width: "85" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(scope) {
                                              return [
                                                _vm.isEstadoAp
                                                  ? _c("app-action-button", {
                                                      attrs: {
                                                        disabled: !_vm.isDocumentoParaVisualizacao(
                                                          scope.row
                                                        ),
                                                        cor: !_vm.isDocumentoParaVisualizacao(
                                                          scope.row
                                                        )
                                                          ? "#C0C4CC"
                                                          : "#666666",
                                                        text: !_vm.isDocumentoParaVisualizacao(
                                                          scope.row
                                                        )
                                                          ? "Não é possível exibir esse arquivo"
                                                          : "Visualizar",
                                                        icone: "eye",
                                                        fontSize: "18"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.abrirDocumento(
                                                            scope.row
                                                          )
                                                        }
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _c("app-action-button", {
                                                  attrs: {
                                                    icone: "download",
                                                    nome: "file_download",
                                                    hoverColor: "#009f61",
                                                    text: "Baixar anexo"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.download(
                                                        scope.row
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          2
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          }),
          !_vm.isNovaConversa || _vm.isIniciarConversa
            ? _c(
                "div",
                [
                  _c(
                    "validation-observer",
                    { ref: "validation", attrs: { tag: "form" } },
                    [
                      _c(
                        "el-row",
                        { staticClass: "mb" },
                        [
                          _c("el-col", { attrs: { span: 17 } }, [
                            _vm.isNovaConversa || _vm.conversas.length === 0
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "el-row",
                                      [
                                        _c("app-label", {
                                          attrs: {
                                            label: "Assunto:",
                                            required: true
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c("validation-provider", {
                                          attrs: { rules: "required" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("el-input", {
                                                      staticClass:
                                                        "input width90",
                                                      class: {
                                                        erro: errors.length
                                                      },
                                                      attrs: {
                                                        name: "assunto"
                                                      },
                                                      model: {
                                                        value: _vm.assunto,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.assunto = $$v
                                                        },
                                                        expression: "assunto"
                                                      }
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "help erro"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            52258859
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.conversas &&
                            _vm.conversas.length > 0 &&
                            !_vm.isNovaConversa &&
                            !_vm.isSolicitacaoAcesso
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "el-row",
                                      [
                                        _c("app-label", {
                                          attrs: {
                                            label: "Status:",
                                            required: true
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("el-row", [
                                      _c(
                                        "div",
                                        { staticClass: "radio" },
                                        [
                                          _c(
                                            "el-radio-group",
                                            {
                                              model: {
                                                value: _vm.fecharConversa,
                                                callback: function($$v) {
                                                  _vm.fecharConversa = $$v
                                                },
                                                expression: "fecharConversa"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-radio",
                                                { attrs: { label: true } },
                                                [_vm._v("Fechar conversa")]
                                              ),
                                              _c(
                                                "el-radio",
                                                { attrs: { label: false } },
                                                [_vm._v("Enviar Mensagem")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]),
                          !_vm.isSolicitacaoAcesso
                            ? _c("el-col", { attrs: { span: 7 } }, [
                                _vm.conversas.length >= 0
                                  ? _c(
                                      "div",
                                      [
                                        !_vm.fecharConversa
                                          ? _c(
                                              "el-row",
                                              [
                                                _c("app-label", {
                                                  attrs: {
                                                    label:
                                                      "Data de vencimento:",
                                                    required: true
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        !_vm.fecharConversa ||
                                        _vm.isNovaConversa
                                          ? _c(
                                              "el-row",
                                              [
                                                _c("validation-provider", {
                                                  attrs: {
                                                    rules: {
                                                      required: !_vm.fecharConversa
                                                    }
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c(
                                                              "el-date-picker",
                                                              {
                                                                staticClass:
                                                                  "input date",
                                                                class: {
                                                                  erro:
                                                                    errors.length
                                                                },
                                                                attrs: {
                                                                  disabled:
                                                                    "disabled",
                                                                  type: "date",
                                                                  placeholder:
                                                                    "Prazo",
                                                                  format:
                                                                    "dd/MM/yyyy",
                                                                  "picker-options":
                                                                    _vm.options
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.prazo,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.prazo = $$v
                                                                  },
                                                                  expression:
                                                                    "prazo"
                                                                }
                                                              }
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "help erro"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    3325415833
                                                  )
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _c("div", { staticClass: "display-flex" }, [
                        _c(
                          "div",
                          { staticClass: "label-width" },
                          [
                            _c("app-label", {
                              attrs: { label: "Mensagem:", required: true }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "btn",
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.openModalNotificacao()
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "center" }, [
                                  _c("i", { staticClass: "fa fa-file icon" }),
                                  _c("b", [_vm._v("  Modelo")])
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-editor-texto", {
                                    ref: "editorTexto",
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: { value: _vm.mensagem },
                                    on: { onTextChange: _vm.onTextChange }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1125177920
                        )
                      }),
                      _c("h4", [_vm._v("Anexos mensagem")]),
                      _c("app-anexo", {
                        attrs: {
                          id: "upload-notificacao",
                          exibirDownload: false,
                          files: _vm.anexos,
                          scope: "anexos"
                        },
                        on: {
                          removeFile: _vm.removeFile,
                          uploadFile: _vm.uploadFile
                        },
                        model: {
                          value: _vm.anexos,
                          callback: function($$v) {
                            _vm.anexos = $$v
                          },
                          expression: "anexos"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "default", size: "small" },
                on: {
                  click: function($event) {
                    return _vm.$emit("closeModal")
                  }
                }
              },
              [
                _c("span", { staticClass: "center" }, [
                  _c("i", { staticClass: "fa fa-times" }),
                  _c("b", [_vm._v("  Cancelar")])
                ])
              ]
            ),
            !_vm.isNovaConversa || _vm.isIniciarConversa
              ? _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { type: "success", size: "small" },
                    on: {
                      click: function($event) {
                        return _vm.sendMessage()
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "center" }, [
                      _c("i", { staticClass: "fa fa-share-square" }),
                      _c("b", [_vm._v("  Enviar")])
                    ])
                  ]
                )
              : _vm._e(),
            _vm.isNovaConversa && !_vm.isIniciarConversa
              ? _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { type: "success", size: "small" },
                    on: {
                      click: function($event) {
                        _vm.isIniciarConversa = true
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "center" }, [
                      _c("i", { staticClass: "fa fa-share-square" }),
                      _c("b", [_vm._v("  Iniciar nova Conversa")])
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79379f32", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79379f32","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/modal/AppModalNotificarInteressado.vue
// module id = null
// module chunks = 